import React from 'react'
import { motion } from 'framer-motion';
import ResumeCard from './ResumeCard';

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          {/* <p className="text-sm text-designColor tracking-[4px]">2017 - 2024</p> */}
          {/* <h2 className="text-3xl md:text-4xl font-bold">Education Quality</h2> */}
        </div>
        {/* <div className=" lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10"> */}
        <div className="relative w-full flex flex-col gap-10">
        <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-black bg-opacity-30"></div>
          <ResumeCard
            title="University of Massachusetts Amherst"
            subTitle="Master of Science in Computer Science (Feb 2023 - Present)"
            result={<span style={{ color: '#38b2ac' }}>3.90/4</span>}
            des="Relevant Courses: Machine Learning, Reinforcement Learning, Distributed Operating System, Software Engineering, Advance Algorithms."
          />
          <ResumeCard
            title="Vnr Vignana Jyothi Institute of Engineering and Technology"
            subTitle="Bachelor of Technology in Information Technology (Aug 2017 - May 2021)"
            result={<span style={{ color: '#38b2ac' }}>9.4/10</span>}
            des="Relevant Courses: Data Structures, Algorithms, Database Management, Object-Oriented Programming, Computer Networks."
          />
          {/* <ResumeCard
            title="Secondary School Education"
            subTitle="Kingstar Secondary School (1998 - 2000)"
            result="5.00/5"
            des="Secondary education or post-primary education covers two phases on the International Standard Classification of Education scale."
          /> */}
        </div>
      </div>
      {/* part Two */}

      {/* <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2010 - 2022</p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Sr. Software Engineer"
            subTitle="Google Out Tech - (2017 - Present)"
            result="USA"
            des="Google's hiring process is an important part of our culture. Googlers care deeply about their teams and the people who make them up."
          />
          <ResumeCard
            title="Web Developer & Trainer"
            subTitle="Apple Developer Team - (2012 - 2016)"
            result="MALAYSIA"
            des="A popular destination with a growing number of highly qualified homegrown graduates, it's true that securing a role in Malaysia isn't easy."
          />
          <ResumeCard
            title="Front-end Developer"
            subTitle="Nike - (2020 - 2011)"
            result="Oman"
            des="The Oman economy has grown strongly over recent years, having transformed itself from a producer and innovation-based economy."
          />
        </div>
      </div> */}
    </motion.div>
  );
}

export default Education


// import React from 'react';
// import { motion } from 'framer-motion';
// import ResumeCard from './ResumeCard';

// const Education = () => {
//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1, transition: { duration: 0.5 } }}
//       className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
//     >
//       <div>
//         <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
//           {/* <p className="text-sm text-designColor tracking-[4px]">2017 - 2024</p> */}
//           {/* <h2 className="text-3xl md:text-4xl font-bold">Education Quality</h2> */}
//         </div>
//         <div className="relative w-full flex flex-col gap-10">
//           <div className="absolute left-4 top-0 bottom-0 w-[2px] bg-[#DAA520]"></div>
//           <div className="relative flex items-center">
//             <div className="absolute left-0 w-[16px] h-[2px] bg-[#DAA520]"></div>
//             <ResumeCard
//               title="University of Massachusetts Amherst"
//               subTitle="Master of Science in Computer Science (Feb 2023 - Present)"
//               result={<span style={{ color: '#DAA520' }}>3.90/4</span>}
//               des="Relevant Courses: Machine Learning, Reinforcement Learning, Distributed Operating System, Software Engineering, Advanced Algorithms."
//             />
//           </div>
//           <div className="relative flex items-center">
//             <div className="absolute left-0 w-[16px] h-[2px] bg-[#DAA520]"></div>
//             <ResumeCard
//               title="Vnr Vignana Jyothi Institute of Engineering and Technology"
//               subTitle="Bachelor of Technology in Information Technology (Aug 2017 - May 2021)"
//               result={<span style={{ color: '#DAA520' }}>9.4/10</span>}
//               des="Relevant Courses: Data Structures, Algorithms, Database Management, Object-Oriented Programming, Computer Networks."
//             />
//           </div>
//         </div>
//       </div>
//     </motion.div>
//   );
// };

// export default Education;

